import { Avatar, Button, Modal } from "antd";
import MentorshipActions from "./MentorshipActions";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import {
	CompanyInternshipState,
	MentorshipDTO,
	ResearchProposalType,
	Role,
} from "../../Api";
import { useTranslation } from "react-i18next";
import { PropsWithChildren, useState } from "react";
import ConfirmationModal from "../../Containers/ConfirmationModal";
import RejectInternship from "../Internships/RejectInternship";
import { MentorshipListProps } from "../../PropsLists/MentorshipListProps";

const MentorshipList = (props: PropsWithChildren<MentorshipListProps>) => {
	const { t } = useTranslation();
	const [mentorModalVisible, setMentorModalVisible] = useState(false);
	const [selectedMentor, setSelectedMentor] = useState<any>(null);

	const handleViewMentor = (mentor: any) => {
		setSelectedMentor(mentor);
		setMentorModalVisible(true);
	};

	return (
		<>
			{props.loading && !props.data && (
				<div className="w-full py-10 text-center">Loading</div>
			)}
			{props.data?.data.length === 0 && (
				<div className="w-full py-10 text-center">
					{t("tableText.noOffers")}
				</div>
			)}

			<div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 xxl:grid-cols-4 gap-4">
				{props.data?.data.map((item: MentorshipDTO) => (
					<div
						className="bg-white rounded-md shadow-md p-4 flex flex-col gap-4"
						key={item.id}
					>
						<div className="flex justify-between gap-6">
							<div className="flex flex-col gap-2">
								<Link
									to={{
										pathname: `/profil`,
										state: {
											id: item.companyId || item.recruiterId,
											userType: Role.Company,
											filters: props.checkedKeys,
											searchTerm: props.searchTerm,
											sortField: props.sortField,
											sortDirection: props.sortDirection,
											currentPage: props.currentPage,
											pageSize: props.pageSize,
											origin: props.location.pathname,
										},
									}}
								>
									<Avatar src={item.recruiterAvatar} />
									<span className="text-secondary">{item.recruiterName}</span>
								</Link>

								<Link
									to={{
										pathname: "/propunere/" + item.id,
										state: {
											id: item.id,
											filters: props.checkedKeys,
											searchTerm: props.searchTerm,
											sortField: props.sortField,
											sortDirection: props.sortDirection,
											currentPage: props.currentPage,
											pageSize: props.pageSize,
											origin: props.location.pathname,
										},
									}}
									className="text-lg text-secondary font-bold flex items-center gap-2 line-clamp-2 overflow-ellipsis"
								>
									<FontAwesomeIcon icon={solid("arrow-up-right-from-square")} />
									{item.internshipName}
								</Link>
							</div>
						</div>

						<div className="line-clamp-5 overflow-ellipsis">
							{item.shortDescription}
						</div>

						<MentorshipActions item={item} />
						<div className="flex flex-col gap-2">
							<Button
								onClick={() =>
									handleViewMentor({
										name: item.mentorName || item.recruiterName,
										cnp: item.mentorCNP,
										description: item.mentorDescription,
									})
								}
								title={t("internships.viewMentor")}
								icon={
									<FontAwesomeIcon
										icon={solid("user-tie")}
										style={{ paddingRight: "5%" }}
									/>
								}
							>
								{t("internships.viewMentorDetails")}
							</Button>
							<Modal
								open={mentorModalVisible}
								onCancel={() => setMentorModalVisible(false)}
								title={t("internships.mentorDetails", "Mentor Details")}
								footer={null}
							>
								{selectedMentor && (
									<div className="flex flex-col gap-2">
										<div>
											<b>{t("account.name")}: </b>
											{selectedMentor.name}
										</div>
										{selectedMentor.cnp && (
											<div>
												<b>{t("account.cnp")}: </b>
												{selectedMentor.cnp}
											</div>
										)}
										{selectedMentor.description && (
											<div>
												<b>{t("account.mentorDescription")}: </b>
												<div
													dangerouslySetInnerHTML={{
														__html: selectedMentor.description || "",
													}}
												/>
											</div>
										)}
									</div>
								)}
							</Modal>
							{item.state === CompanyInternshipState.PendingApproval && (
								<>
									<div className="flex flex-col">
										<Button
											onClick={() => {
												props.actions.setSelectedInternshipId(item.id);
												props.actions.setApproveModalVisibility(true);
											}}
											title={t("internships.approveInternship")}
											icon={
												<FontAwesomeIcon
													icon={solid("circle-check")}
													style={{ paddingRight: "5%" }}
												/>
											}
										>
											{t("internships.approveInternship")}
										</Button>

										<ConfirmationModal
											modalText={t("internships.approveInternshipMessage")}
											handleFunction={props.actions.approve}
											modalVisibility={props.state.approveModalVisibility}
											title=""
											changeModalVisibility={() =>
												props.actions.setApproveModalVisibility(false)
											}
											spinning={props.state.spinning}
										/>
									</div>

									<RejectInternship
										nameButton={"  " + t("internships.rejectInternship")}
										modalText={t("internships.rejectInternshipMessage")}
										title={t("internships.rejectInternship")}
										handleFunction={(description: string) =>
											props.actions.reject(item, description)
										}
										modalVisibility={props.state.rejectModalVisibility}
										iconButton={
											<FontAwesomeIcon
												icon={solid("ban")}
												style={{ paddingRight: "5%" }}
											/>
										}
										spinning={props.state.spinning}
									/>
								</>
							)}
						</div>
					</div>
				))}
			</div>
		</>
	);
};

export default MentorshipList;
